import {Link} from 'react-router';

import {dataTableActionT, dataTableColumnT} from '@/lib/types/dataTable.types';
import {distributorT} from '@/lib/types/distributor.types';

export const renderDistributorTableStats = (
  totalDistributors: number | undefined | null,
  activeDistributors: number | undefined | null,
  inactiveDistributors: number | undefined | null
) => [
  {
    title: 'Total Distributors',
    value: totalDistributors,
    subtitle: 'This Month',
    change: 1.03,
    icon: 'ri-price-tag-3-line',
    color: 'primary',
    cardClass: 'bg-primary/10 text-primary',
  },
  {
    title: 'Active Distributors',
    value: activeDistributors,
    subtitle: 'This Month',
    change: 0.36,
    icon: 'ri-check-line',
    color: 'secondary',
    cardClass: 'bg-secondary/10 text-secondary',
  },
  {
    title: 'Inactive Distributors',
    value: inactiveDistributors,
    subtitle: 'This Month',
    change: -1.28,
    icon: 'ri-close-line',
    color: 'warning',
    cardClass: 'bg-warning/10 text-warning',
  },
];

export const distributorColumns: dataTableColumnT<'Distributor'>[] = [
  {header: 'Distributor ID', field: 'distributor_id'},
  {
    header: 'Status',
    field: 'date_created',
    render: distributor => (
      <span className={`badge bg-${!distributor.date_removed ? 'success' : 'danger'} text-white`}>
        {!distributor.date_removed ? 'Active' : 'Inactive'}
      </span>
    ),
  },
  {
    header: 'Name',
    field: 'distributor_name',
    render: (distributor: distributorT) => (
      <Link
        className="text-primary hover:text-primary dark:text-primary"
        to={`/distributors/${distributor.distributor_id}`}
      >
        {distributor.distributor_name}
      </Link>
    ),
  },
  {header: 'Address', field: 'distributor_address'},
  {header: 'City', field: 'distributor_city'},
  {header: 'State', field: 'distributor_state'},
  {header: 'Postal Code', field: 'distributor_postal_code'},
  {header: 'License Number', field: 'distributor_license_number'},
  {header: 'Created', field: 'date_created'},
  {header: 'Modified', field: 'date_modified'},
];

export const distributorActions = (
  isAdmin: boolean,
  handleEditDistributorClick: (row: distributorT) => void,
  handleDeleteDistributorClick: (row: distributorT) => void
): dataTableActionT<'Distributor'>[] => [
  {
    icon: 'ri-pencil-line',
    color: 'info',
    handler: (distributor: distributorT) => handleEditDistributorClick(distributor),
    permission: () => isAdmin,
  },
  {
    icon: 'ri-delete-bin-line',
    color: 'danger',
    handler: (distributor: distributorT) => handleDeleteDistributorClick(distributor),
    permission: () => isAdmin,
  },
];
